<!-- 支付结果 -->
<template>
<div class="special-topic-buy-result">
    <div class="result" v-if="init">
        <i class="result-icon el-icon-success" v-if="result.payresult === 1"></i>
        <i class="result-icon el-icon-error" v-if="result.payresult === 0"></i>
        <div class="tips">{{ result.payresult === 1 ? '您的题库购买成功，快去刷题吧！' : '您的题库购买失败，请重新购买！' }}</div>
        <div class="info">
            <img class="examlogo" :src="result.examlogo" />
            <div class="text-info">
                <div class="item">
                    <div class="label">题目名称：</div>
                    <div class="value">{{ result.examname }}</div>
                </div>
                <div class="item">
                    <div class="label">购买科目：</div>
                    <div class="value">{{ result.subjectnames }}</div>
                </div>
                <div class="item">
                    <div class="label">有效时长：</div>
                    <div class="value">12个月</div>
                </div>
            </div>
        </div>
        <div class="btn-box">
            <el-button type="primary" plain @click="handleReturnDetails">返回详情</el-button>
            <el-button type="primary" @click="handleReturnDetails" v-if="result.payresult === 1">前往做题</el-button>
            <el-button type="primary" @click="handleOpenBuy" v-if="result.payresult === 0">重新购买</el-button>
        </div>
    </div>
    <BuyDialog ref="buyDialog"></BuyDialog>
</div>
</template>

<script>
import {queryOrderPayResultByTopicQuestion} from '@/api/specialTopic.js'
import { mapActions } from 'vuex'
import BuyDialog from './component/buyDialog.vue'
import specialTopic from '@/common/js/specialTopic.json'
import subjectBanner1 from '@/common/images/mSpecialTopic/choose/subject_banner1.png'
import subjectBanner2 from '@/common/images/mSpecialTopic/choose/subject_banner2.png'
import subjectBanner3 from '@/common/images/mSpecialTopic/choose/subject_banner3.png'
import subjectBanner4 from '@/common/images/mSpecialTopic/choose/subject_banner4.png'
import subjectBanner5 from '@/common/images/mSpecialTopic/choose/subject_banner5.png'
import subjectBanner6 from '@/common/images/mSpecialTopic/choose/subject_banner6.png'
import subjectBanner7 from '@/common/images/mSpecialTopic/choose/subject_banner7.png'
import subjectBanner8 from '@/common/images/mSpecialTopic/choose/subject_banner8.png'
import subjectBanner9 from '@/common/images/mSpecialTopic/choose/subject_banner9.png'
import subjectBanner10 from '@/common/images/mSpecialTopic/choose/subject_banner10.png'
import subjectBanner11 from '@/common/images/mSpecialTopic/choose/subject_banner11.png'
import subjectBanner12 from '@/common/images/mSpecialTopic/choose/subject_banner12.png'
import subjectBanner13 from '@/common/images/mSpecialTopic/choose/subject_banner13.png'
import subjectBanner14 from '@/common/images/mSpecialTopic/choose/subject_banner14.png'
import subjectBanner15 from '@/common/images/mSpecialTopic/choose/subject_banner15.png'
import subjectBanner16 from '@/common/images/mSpecialTopic/choose/subject_banner16.png'
import jjcylogo from '@/common/images/specialTopic/examlogo/jjcy_logo.jpg'
import zqcylogo from '@/common/images/specialTopic/examlogo/zqcy_logo.jpg'
import qhcylogo from '@/common/images/specialTopic/examlogo/qhcy_logo.jpg'
export default {
    data() {
        return {
            result: {
                payresult: 0, // 支付结果 0未成功 1已成功
                orderno: '', // 订单号
                examname: '', // 考证名称
                examcode: '',
                examlogo: '', // 考证Logo
                subjectnames: '', // 开通科目
                expiredate: '' // 有效时间 yyyy-MM-dd
            },
            init: false,
            subjectBanner1,
            subjectBanner2,
            subjectBanner3,
            subjectBanner4,
            subjectBanner5,
            subjectBanner6,
            subjectBanner7,
            subjectBanner8,
            subjectBanner9,
            subjectBanner10,
            subjectBanner11,
            subjectBanner12,
            subjectBanner13,
            subjectBanner14,
            subjectBanner15,
            subjectBanner16,
            subjectCodeBanner: {}
        }
    },
    // 生命周期 - 创建完成（访问当前this实例）
    created() {
        if (this.$route.query.orderno && this.$route.query.result && this.$route.query.rid && this.$route.query.sign) {
            this.handleQueryOrderPayResultByTopicQuestion()
        } else {
            location.href = '/m/error504'
        }
        ;[...specialTopic.buySubjectList[0].subjectList, ...specialTopic.buySubjectList[1].subjectList, ...specialTopic.buySubjectList[2].subjectList].forEach(item => {
            this.subjectCodeBanner[item.subjectcode] = this[item.bannername]
        })
    },
    // 生命周期 - 挂载完成（访问DOM元素）
    mounted() {

    },
    methods: {
        handleQueryOrderPayResultByTopicQuestion() {
            this.setLoading(true)
            queryOrderPayResultByTopicQuestion({
                data: {
                    orderno: this.$route.query.orderno,
                    result: this.$route.query.result,
                    rid: this.$route.query.rid,
                    sign: this.$route.query.sign
                },
                success: data => {
                    // data.data.examcode = this.$route.params.examcode
                    data.data.examlogo = this.subjectCodeBanner[data.data.subjectcodes]
                    if (!data.data.examlogo) {
                        if (data.data.examcode === 'jjcy') {
                            data.data.examlogo = jjcylogo
                        } else if (data.data.examcode === 'zqcy') {
                            data.data.examlogo = zqcylogo
                        } else if (data.data.examcode === 'qhcy') {
                            data.data.examlogo = qhcylogo
                        }
                    }
                    this.result = data.data
                    this.setLoading(false)
                    this.init = true
                },
                error: error => {
                    this.setLoading(false)
                    this.$message.error(error.msg)
                }
            })
        },
        handleReturnDetails() {
            window.location.replace(location.origin + '/specialTopic/' + this.result.examcode + '/topic')
        },
        handleOpenBuy() {
            this.$refs.buyDialog.handleOpen(this.result.examcode)
        },
        ...mapActions([
            'setLoading'
        ])
    },
    components: {
        BuyDialog
    }
}
</script>
<style lang='scss'>
/* @import url(); 引入css类 */
.special-topic-buy-result {
    height: 100%;
    background: #fff;
    .result {
        width: 445px;
        margin: 0 auto;
        padding-top: 100px;
        .result-icon {
            font-size: 56px;
            display: block;
            margin: 0 auto 20px;
            width: 56px;
            height: 56px;
            &.el-icon-success {
                color: #0ABF53;
            }
            &.el-icon-error {
                color: #FF4747;
            }
        }
        .tips {
            font-size: 16px;
            color: #333333;
            line-height: 22px;
            text-align: center;
            margin-bottom: 30px;
        }
        .info {
            width: 445px;
            padding: 12px 20px;
            box-sizing: border-box;
            background: #F5F5F5;
            display: flex;
            align-items: center;
            margin-bottom: 60px;
            .examlogo {
                width: 124px;
                height: 70px;
                margin-right: 15px;
            }
            .text-info {
                flex: 1;
                width: 0;
                .item {
                    display: flex;
                    .label {
                        line-height: 24px;
                        font-size: 14px;
                        color: #666666;
                        width: 70px;
                        min-width: 70px;
                    }
                    .value {
                        line-height: 24px;
                        font-size: 14px;
                        color: #333333;
                        flex: 1;
                        width: 0;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        white-space: nowrap;
                    }
                }
            }
        }
        .btn-box {
            display: flex;
            align-items: center;
            justify-content: center;
            .el-button {
                width: 160px;
                height: 40px;
                &:first-of-type {
                    margin-right: 20px;
                }
            }
        }
    }
}
</style>